// ----------------------------------------------------
// src/App.js
// ----------------------------------------------------
// Developed by Mithil Patoliya

import React, { useEffect } from "react";
import Navbar from "./Components/Navbar";
import Routes from "./Routes";
import "./App.css";
import Footer from './Components/FooterSection';

const App = () => {

  useEffect(() => {
    // Detect page refresh
    if (window.performance) {
      const navEntries = performance.getEntriesByType("navigation");

      if (navEntries.length > 0 && navEntries[0].type === "reload") {
        window.location.replace("/");
      }
    }
  }, []);

  return (
    <>
      <Navbar />
      <Routes />
      <Footer />
    </>
  );
};

export default App;